// @ts-check

import React, { Component, Fragment } from "react"
import { Input, TextArea } from "ui"
import DefineAction from "../../actions/DefineAction"
import { text, boolean } from "../../attributes/items/primitives"
import DefineProperty from "../../properties/DefineProperty"
import { evaluateFormulas } from "../../formulas/evaluate"

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
export default class InputBlocktype extends Component {
    state = {
        value: "",
    }
    clear = () => {
        return new Promise((resolve, reject) => this.setState({ value: "" }, resolve))
    }
    constructor(props) {
        super(props)
        const evaluate = evaluateFormulas(props.context)
        if (props.config.attributes.defaultValue) {
            this.state.value = evaluate(props.config.attributes.defaultValue)
        }
    }

    componentWillReceiveProps(newProps) {
        const evaluate = evaluateFormulas(newProps.context)
        const evaluateOld = evaluateFormulas(this.props.context)
        const newVal = evaluate(newProps.config.attributes.defaultValue)
        const oldVal = evaluateOld(this.props.config.attributes.defaultValue)
        if (oldVal !== newVal) {
            this.setState({ value: newVal })
        }
    }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => (
                    <Fragment>
                        <DefineProperty
                            name={attrs.name || this.props.id}
                            description="input value"
                            type="string"
                            value={this.state.value}
                            onPersistedValue={value => this.setState({ value })}
                            tags={["form"]}
                        />

                        {attrs.multiline ? (
                            <TextArea
                                style={{ ...computedStyle, width: "100%", height: "100%" }}
                                value={this.state.value}
                                placeholder={attrs.placeholder}
                                onChange={event => {
                                    this.setState({ value: event.target.value })
                                }}
                            />
                        ) : (
                            <Input
                                style={{ ...computedStyle, width: "100%" }}
                                value={this.state.value}
                                placeholder={attrs.placeholder}
                                onChange={event => {
                                    this.setState({ value: event.target.value })
                                }}
                            />
                        )}
                        <DefineAction name={this.props.id + ": Clear Input"} action={this.clear} />
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

InputBlocktype.attributes = [
    text({ field: "name", label: "Field Name" }),
    text({ field: "placeholder", label: "Placeholder" }),
    boolean({ field: "multiline", label: "Text area?" }),
    text({ field: "defaultValue", label: "Starting value" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/InputBlock.js